export const locales = {
  dateFormat: 'DD/MM/YYYY',
  dateTimeFormat: 'MMM D, YYYY h:mma',
  currency: 'NZD',
};

export const prompts = {
  ajaxErrorTitle: 'Error',
  ajaxError_Generic:
    'Unfortunately we were unable to process your request.Please try again and if the problem persists, please contact your Account Manager.',
  ajaxError_401:
    'Either you have been timed out or you do not have the permission to run this operation. Please try again by logging out and logging back in. If the problem persists, please contact your Account Manager.',
  ajaxError_403:
    'Either you have been timed out or you do not have the permission to run this operation. Please try again by logging out and logging back in. If the problem persists, please contact your Account Manager.',
  contactTypes: {
    PW: 'Work phone',
    PM: 'Mobile phone',
    PH: 'Home phone',
    PE: 'Emergency phone',
    EM: 'Email',
    CW: 'Clubware',
    CE: 'Clubware email',
    CP: 'Clubware phone',
    PV: 'Previous',
    FX: 'Fax',
  },
  accountType: {
    BA: 'Bank Account',
    CC: 'Credit Card',
  },
  transactionType: {
    I: 'Invoice',
    R: 'Receipt',
  },
  paymentType: {
    DD: 'Direct Debit',
    AP: 'Automatic Payment',
    CC: 'Credit Card',
    BI: 'Bank Import',
    CH: 'Cash',
    CQ: 'Cheque',
    DT: 'Debt Collection',
    DC: 'Direct Credit',
    MO: 'Money Order',
    PC: 'Paid To Facility',
    TB: 'Telephone Banking',
    TR: 'Transfer',
    SU: 'Suspense',
    EF: 'EFTPOS',
    MR: 'Manual Receipting',
    RA: 'ReAllocation',
    CO: 'Credit Card Other',
    CU: 'Credit Union',
    BP: 'BPAY',
    ZC: 'Credit Card',
    ZO: 'Credit Card Other',
    WC: 'Web-Pay',
    WO: 'Web-Pay Other',
  },
  transactionCode: {
    PY: 'Payment',
    DP: 'Debt collection payment',
    DF: 'Debt collection fee',
    EF: 'Establishment fee',
    MS: 'Miscellaneous fee',
    PD: 'Paid at business',
    PF: 'Penalty fee',
    OP: 'One off payment',
    DC: 'Debt call fee',
    PV: 'Payment variation fee',
    ST: 'Statement fee',
    AT: 'Account transfer',
    TF: 'Transfer fee',
    SV: 'Service',
    CM: 'Commission',
    DO: 'Document preparation fee',
    JG: 'Judgement',
    AO: 'Attachment order',
    EO: 'Examination order',
    NO: 'Notice of proceedings',
    CO: 'Correspondence',
    AF: 'Agent fee',
    FC: 'Field call',
    TC: 'Trace fee',
    CC: 'Case close fee',
    RF: 'Refund',
    VF: 'Variation fee',
    FV: 'Facility variation fee',
    SU: 'Suspension fee',
    CF: 'Cancellation fee',
    SR: 'Surcharge',
    FD: 'Default fee',
  },
  transErrorCode: {
    NA: 'No authority',
    AC: 'Account closed',
    IF: 'Insufficient funds',
    AS: 'Authority stopped',
    NE: '',
    IA: 'Invalid account',
    DL: 'Declined',
    XC: 'Card expired',
    RC: 'Restricted card',
    LC: 'Lost or stolen card',
  },
  callHow: {
    PHI: 'Phone in',
    PHO: 'Phone out',
    STF: 'Staff',
    EMI: 'Email in',
    EMO: 'Email out',
    FXI: 'Fax in',
    FXO: 'Fax out',
    LTI: 'Letter in',
    LTO: 'Letter out',
    CBW: 'Clubware',
    SYS: 'System',
    VIS: 'Visit',
    WEB: 'Website',
    WSI: 'Web service internal',
    WSE: 'Web service external',
    SMS: 'Sms in',
    SMO: 'Sms out',
  },
  callPurpose: {},
  addressType: {
    BS: 'Business',
    HM: 'Home',
    PH: 'Physical',
    PO: 'Postal',
    PV: 'Previous',
    CW: 'ClubWare',
    LE: 'Legal',
  },
  termType: {
    M: 'Month(s)',
    P: 'Payment(s)',
  },
};
